export default __webpack_public_path__ + "static/media/004-B-voiture.0e4af7f7.svg";